const redirectUri = process.env.NODE_ENV === 'production'
  ? 'https://trk-concierge-spsupport.net/login'     
  : 'http://localhost:3000';

export const msalConfig = {
  auth: {
    clientId: 'a4e1aa5e-27c5-400c-b004-f6ba61339c8d', // Azure ADアプリのクライアントID
    authority: 'https://login.microsoftonline.com/05a6dd31-dbec-4a4f-a8cd-2eada561cecf', // またはテナントID指定
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
